import React, { Component } from "react";
import styles from "./vehicleReportTable.module.scss";

class VehicleReportTableHeader extends Component {
  getHedeaderItem(item, index) {
    return (
      <div
        key={"reportTanbleHeader" + index}
        className={styles.reportTableHeaderItem}
        style={{
          width: item.width + "px",
        }}
      >
        <b>{item.title}</b>
      </div>
    );
  }

  render() {
    const { header } = this.props;

    return (
      <div className={styles.reportTableHeaderContainer}>
        {header.map((item, index) => {
          return this.getHedeaderItem(item, index);
        })}
      </div>
    );
  }
}

export default VehicleReportTableHeader;
